import { get } from 'svelte/store';
import { storeBackendUrl, storeAccessToken, storeError } from '../store';
import { storeActus, emptyActu } from '../classes/actu';
import { authentication } from './api';
/**
 * getActus
 * /actus/ - GET
 */
export async function getActus() {
    const apiUrl = get(storeBackendUrl) + "v1/actus/";
    await authentication();
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(storeAccessToken));
    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache'
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        storeActus.set(data);
        console.log("getActus");
        console.log(data);
        storeError.set("");
        return true;
    })
        .catch((error) => {
        const emptyActus = new Array(emptyActu);
        storeActus.set(emptyActus);
        storeError.set(error);
        return false;
    });
}
